import React from 'react'

export default function SectionWrapper({ id, dark = false, noSnap = false, children, className = '', ...rest }) {
  return (
    <section
      id={id}
      className={`py-16 md:py-20 ${noSnap ? '' : 'snap-section'} ${dark ? 'bg-color-primary text-primary-on-dark' : ''} ${className}`}
      {...rest}
    >
      <div className="max-w-content mx-auto px-6">
        {children}
      </div>
    </section>
  )
}
